import { useState, useEffect } from "react";

//MUI
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import Modal from "@mui/material/Modal";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import "../ModalAtribuirPerfis/ModalAtribuirPerfis.scss";

import toast from "react-hot-toast";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

/**
 * Unidades a que um utilizador fica associado.
 *
 * NENHUMA ESCOLHIDA = acesso a TODAS. Não é um estado por preencher: é como se
 * exprime "esta pessoa vê tudo" (o administrador), e é o estado de todos os
 * utilizadores anteriores a esta funcionalidade — por isso nada se partiu ao
 * introduzi-la.
 *
 * A escolha decide as unidades que aparecem no login e limita o que a pessoa vê
 * no fecho e no fluxo de caixa. A verificação é feita no servidor; este ecrã é
 * só a forma de a configurar.
 */
function ModalAtribuirUnidades({
  modalData,
  handleCloseModal,
  sendRequest,
  auth,
  handleUpdateUtilizador,
  unidades,
}) {
  const { startLoading, stopLoading } = useLoading();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selecionadas, setSelecionadas] = useState([]);

  useEffect(() => {
    if (!modalData.user) return;
    setSelecionadas(
      (modalData.user.estabelecimentos || []).map((u) =>
        typeof u === "object" ? u._id : u,
      ),
    );
  }, [modalData.user]);

  const submit = async () => {
    startLoading();
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      // Enviado sempre, mesmo vazio: é assim que se RETIRA uma restrição e se
      // devolve o acesso a todas as unidades.
      formData.append("estabelecimentos", JSON.stringify(selecionadas));

      const resposta = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/users/${modalData.user._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      toast.success(
        selecionadas.length === 0
          ? "Utilizador com acesso a todas as unidades."
          : "Unidades associadas ao utilizador com sucesso!",
      );
      if (handleUpdateUtilizador) handleUpdateUtilizador(resposta.user);
      handleCloseModal();
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsSubmitting(false);
      stopLoading();
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelecionadas(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <Modal
      open={modalData.open === "atribuirUnidades"}
      onClose={handleCloseModal}
      aria-labelledby="modal-atribuir-unidades"
    >
      <Box
        className="fluxo-atendimento__modal__box credencial__modal"
        id="modal__credencial"
      >
        <h1 className="fluxo-atendimento__modal__titulo">
          Unidades do Utilizador
        </h1>

        <div className="modalAdicionarPerfil__container">
          <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="unidades-label">Unidades</InputLabel>
            <Select
              labelId="unidades-label"
              id="unidades-select"
              multiple
              value={selecionadas}
              onChange={handleChange}
              input={<OutlinedInput label="Unidades" />}
              renderValue={(selected) =>
                selected.length === 0 ? (
                  <em>Todas as unidades</em>
                ) : (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((id) => {
                      const u = unidades.find((x) => x._id === id);
                      return <Chip key={id} label={u ? u.nome : id} />;
                    })}
                  </Box>
                )
              }
              MenuProps={MenuProps}
            >
              {unidades.map((u) => (
                <MenuItem key={u._id} value={u._id}>
                  <Checkbox checked={selecionadas.indexOf(u._id) > -1} />
                  <ListItemText primary={`${u.nome} (${u.codigo})`} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <p
          style={{
            fontSize: "13px",
            color: "#666",
            margin: "0 8px 8px",
            lineHeight: 1.4,
          }}
        >
          Sem nenhuma unidade escolhida, o utilizador tem acesso a todas. Com
          uma ou mais, só poderá iniciar sessão nessas e só verá o fecho e o
          fluxo de caixa dessas.
        </p>

        <div className="fluxo-atendimento__modal__bottom_btns">
          <span
            className="cancel-btn"
            onClick={handleCloseModal}
            style={{ display: "block" }}
          >
            Fechar
          </span>
          <span
            className="blue-button"
            disabled={isSubmitting}
            onClick={submit}
            style={{ display: "block" }}
          >
            {isSubmitting ? "Guardando..." : "Guardar"}
          </span>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalAtribuirUnidades;
